import React from 'react'
import styled from 'styled-components'
import { IGif } from '@giphy/js-types'
import { giphyYellow } from '@giphy/js-brand'

const ClockContainer = styled.div`
    align-items: flex-end;
    justify-content: flex-start;
    display: flex;
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
`
const Icon = styled.div`
    margin-left: 6px;
    margin-bottom: 4px;
    font-size: 15px;
    line-height: 15px;
    color: ${giphyYellow};
`
const ClockOverlay = ({ gif }: { gif: IGif }) =>
    gif.is_scheduled ? (
        <ClockContainer>
            <Icon className="ss-clock" />
        </ClockContainer>
    ) : null

export default ClockOverlay
